/**
 * BIRHAUS Constants
 * 
 * Core limits and configuration values that enforce BIRHAUS principles
 */

export const BIRHAUS_LIMITS = {
  // Cognitive Load Limits (Miller's Law: 7±2)
  MAX_VISIBLE_CHOICES: 7,
  MIN_VISIBLE_CHOICES: 5,
  
  // 4-3-1 Rule (Core BIRHAUS Navigation)
  MAX_PRIMARY_NAV_ITEMS: 4,
  MAX_CONTEXTUAL_ACTIONS: 3,
  MAX_PRIMARY_ACTIONS: 1,
  
  // Form Design Limits
  MAX_FIELDS_PER_STEP: 5,
  MAX_FORM_STEPS: 4,
  
  // Performance Budgets (ms)
  MAX_TTI: 2000,        // Time to Interactive
  MAX_FCP: 1000,        // First Contentful Paint
  MAX_CLS: 0.1,         // Cumulative Layout Shift
  
  // Table Design
  DEFAULT_TABLE_COLUMNS: 7,
  MAX_TABLE_ROWS_BEFORE_VIRTUALIZATION: 100,
  
  // Undo System
  DEFAULT_UNDO_TIMEOUT: 10000,  // 10 seconds
  MAX_UNDO_ACTIONS: 5,
  
  // Accessibility
  MIN_TOUCH_TARGET: 44,    // pixels (WCAG AA)
  MIN_CONTRAST_RATIO: 4.5, // WCAG AA
  
  // Animation
  DEFAULT_TRANSITION_DURATION: 150, // ms
  REDUCE_MOTION_DURATION: 0,        // ms
} as const

export const BIRHAUS_BREAKPOINTS = {
  mobile: 320,
  tablet: 768,  
  desktop: 1024,
  wide: 1440,
} as const

export const BIRHAUS_Z_INDEX = {
  dropdown: 1000,
  tooltip: 1100,
  overlay: 1200,
  modal: 1300,  // Deprecated - BIRHAUS discourages modals
  toast: 1400,
  commandPalette: 1500,
} as const

/**
 * Supported Languages (Spanish-first)
 */
export const BIRHAUS_LANGUAGES = {
  PRIMARY: 'es',      // Spanish (Paraguay)
  SECONDARY: 'en',    // English (International)
} as const

/**
 * Component States for Consistent Design
 */
export const BIRHAUS_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  WARNING: 'warning', 
  ERROR: 'error',
  DISABLED: 'disabled',
} as const